import { RootStores } from '../../common/stores';
import { STORE_ROUTER, STORE_USERS } from '../../common/constants';
import { STORE_SCRIPT_MANAGEMENT } from './constants';
import ScriptManagementStore from './ScriptManagementStore';
import ScriptManagementService from '../services/ScriptManagementService';

export { default as ScriptManagementStore } from './ScriptManagementStore';

export function injectScriptManagementStores(obj: RootStores) {
    const service = new ScriptManagementService();
    obj[STORE_SCRIPT_MANAGEMENT] = new ScriptManagementStore(obj[STORE_ROUTER], obj[STORE_USERS], service);
}

export type ScriptManagementStores = {
    [STORE_SCRIPT_MANAGEMENT]?: ScriptManagementStore;
};
